import React from 'react';
import { Search } from 'lucide-react';
interface SearchBarProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onSearch?: (query: string) => void;
}
export function SearchBar({
  onSearch,
  className = '',
  ...props
}: SearchBarProps) {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && onSearch) {
      onSearch(e.currentTarget.value);
    }
  };
  return <div className={`relative ${className}`} data-id="element-15567">
      <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none" data-id="element-15568">
        <Search className="h-5 w-5 text-slate-400" data-id="element-15569" />
      </div>
      <input type="text" className="block w-full pl-10 pr-4 py-3 border border-slate-200 rounded-xl leading-5 bg-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary sm:text-sm transition-shadow shadow-sm" onKeyDown={handleKeyDown} {...props} data-id="element-15570" />
    </div>;
}